import { deleteCookie } from 'cookies-next';

export const expireCookie = (name: string, domain?: string): void => {
  deleteCookie(name, {
    path: '/',
    domain,
  });
};
